interface Props {
  isOnline: boolean
}

export default function DeviceStatusBadge({ isOnline }: Props) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 12px',
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 600,
        background: isOnline ? '#ecfdf5' : '#fef2f2',
        color: isOnline ? '#059669' : '#dc2626',
      }}
    >
      <span
        style={{
          display: 'inline-block',
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: isOnline ? '#10b981' : '#ef4444',
          boxShadow: isOnline ? '0 0 6px rgba(16,185,129,0.6)' : '0 0 6px rgba(239,68,68,0.4)',
        }}
      />
      {isOnline ? 'Online' : 'Offline'}
    </span>
  )
}
